import React from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Divider,
  Dialog,
  DialogTitle,
 
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AddPartType = ({
  openDialog,
  handleClose,
  typeList,
  register,
  errors,
  formData,
  onAddEditTypeSubmit,
  handleSubmit,
  isEditMode,
  isUpdateButton,
  setIsUpdateButton,
  setValue
}) => {
  return (
    <>
      <Dialog open={openDialog} onClose={handleClose} fullWidth={1}
        maxWidth={"xs"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>
                {!isEditMode
                  ? "Add Part Type"
                  : "Edit Part Type"}
              </b>
            </div>
            <CloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 1 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12}>
                      <TextField
                        className="stepperFormInput"
                        label="Code"
                        name="partTypeCode"
                        fullWidth
                        placeholder="Enter user code"
                        size="small"
                        defaultValue={formData.partTypeCode}
                        required
                        autoComplete="off"
                        {...register("partTypeCode", { required: true })}
                        error={Boolean(errors?.partTypeCode)}
                        helperText={errors?.partTypeCode?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("partTypeCode", str.trim());
                         
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        className="stepperFormInput"
                        label="Name"
                        name="name"
                        placeholder="Enter name"
                        fullWidth
                        required
                        size="small"
                        autoComplete="off"
                        {...register("name", { required: true })}
                        error={Boolean(errors?.name)}
                        helperText={errors?.name?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("name", str.trim());
                         
                        }}
                      />
                    </Grid>
                    
                    
                   
                  </Grid>
                </form>
              </Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 2, pl: 37 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onAddEditTypeSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  disabled={isUpdateButton && isEditMode}
                >
                  {!isEditMode ? "Save" : "Update"}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddPartType;
